/* global axios */
import ApiClient from '../ApiClient';

class CaptainAssistantMedia extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  getMedia(assistantId) {
    return axios.get(`${this.url}/${assistantId}/media`);
  }

  create(assistantId, { key, caption, file }) {
    const formData = new FormData();
    formData.append('key', key);
    if (caption) {
      formData.append('caption', caption);
    }
    formData.append('file', file);
    return axios.post(`${this.url}/${assistantId}/media`, formData);
  }

  delete(assistantId, id) {
    return axios.delete(`${this.url}/${assistantId}/media/${id}`);
  }
}

export default new CaptainAssistantMedia();
